/* eslint-disable max-len */

import React from 'react'
import styled from 'styled-components'

const GowthTutorialStyled = styled.div`
  position: absolute;
  right: 25px;
  bottom: 15px;
  z-index: 2;
`

const TutorialContent = styled.span`
  font-weight: 700;
  font-size: 18px;
  line-height: 20px;
  text-align: left;
  display: inline-block;
  width: 100%;

  letter-spacing: 1px;

  color: #000000;
`

const GowthTutorial = () => (
  <GowthTutorialStyled>
    <svg width="502" height="153" viewBox="0 0 502 153" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M287.642 101.5L381.75 117.596L501.999 135.938L287.642 117.596V101.5Z" fill="#D4D4FA" />
      <g filter="url(#filter0_d_2466_12312)">
        <rect x="16.4888" y="8.15625" width="271.153" height="136.844" rx="10" fill="#DAD9FF" />
        <rect x="16.9888" y="8.65625" width="270.153" height="135.844" rx="9.5" stroke="#D9D9D9" />
      </g>
      <circle cx="21" cy="21" r="20.5" fill="#3B82F6" stroke="#3B82F6" />
      <path
        d="M25.22 16.1886C25.22 17.1752 24.92 17.9619 24.32 18.5486C23.7333 19.1352 23.0067 19.5352 22.14 19.7486V19.8086C23.2733 19.9552 24.14 20.3086 24.74 20.8686C25.34 21.4286 25.64 22.1752 25.64 23.1086C25.64 23.9352 25.4333 24.6819 25.02 25.3486C24.62 26.0019 23.9933 26.5219 23.14 26.9086C22.3 27.2819 21.2133 27.4686 19.88 27.4686C18.3333 27.4686 16.96 27.2086 15.76 26.6886V24.1286C16.3733 24.4352 17.0133 24.6686 17.68 24.8286C18.3467 24.9886 18.9733 25.0686 19.56 25.0686C20.64 25.0686 21.3933 24.8819 21.82 24.5086C22.26 24.1352 22.48 23.6086 22.48 22.9286C22.48 22.5419 22.38 22.2086 22.18 21.9286C21.98 21.6486 21.6267 21.4419 21.12 21.3086C20.6267 21.1619 19.9333 21.0886 19.04 21.0886H17.96V18.7686H19.06C19.94 18.7686 20.6067 18.6886 21.06 18.5286C21.5267 18.3552 21.84 18.1286 22 17.8486C22.1733 17.5552 22.26 17.2219 22.26 16.8486C22.26 16.3419 22.1 15.9486 21.78 15.6686C21.4733 15.3752 20.9533 15.2286 20.22 15.2286C19.54 15.2286 18.9467 15.3486 18.44 15.5886C17.9333 15.8286 17.5133 16.0552 17.18 16.2686L15.78 14.1886C16.34 13.7886 16.9933 13.4552 17.74 13.1886C18.5 12.9219 19.4 12.7886 20.44 12.7886C21.9067 12.7886 23.0667 13.0886 23.92 13.6886C24.7867 14.2752 25.22 15.1086 25.22 16.1886Z"
        fill="white"
      />
      <foreignObject className="node" x="80" y="22" width="200" height="300">
        <TutorialContent>
          click EDIT icon <br />
          and input each <br />
          parameters on below <br />
          diagram and make
          discriptions.
        </TutorialContent>
      </foreignObject>
      <defs>
        <filter
          id="filter0_d_2466_12312"
          x="12.4888"
          y="8.15625"
          width="279.153"
          height="144.844"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2466_12312" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2466_12312" result="shape" />
        </filter>
      </defs>
    </svg>

  </GowthTutorialStyled>
)

export default GowthTutorial
